import { IconProps } from './types';

const Heart = (props: IconProps) => {
  return (
    <svg {...props} width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.9773 4.21096C7.8491 -1.57404 1 1.12753 1 7.02895C1 12.9304 12.7949 21.0012 12.7949 21.0012C12.7949 21.0012 24 12.6065 24 7.02895C24 1.45141 17.6737 -1.57403 13.5455 4.21096L12.7526 5.19862L11.9773 4.21096Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </svg>
  );
};

export default Heart;
